export default __webpack_public_path__ + "static/media/pic5.45b4da4e.svg";